export default customElements.define('w-field-select', class FieldSelect extends wealthify.componentBases.FieldSelection {

    constructor () {
        super();

        this.addEventListener('change', this.#updateValueFromInput);
        this.addEventListener(this.events.ValueChange.name, this.#applyValueToInput);
        this.addEventListener(this.events.ReadOnlyToggled.name, this.#toggleReadOnly);
        this.onConnectedCallback = () => {
            this.#addPlaceholderOption();
        };

        this.#toggleReadOnly();
    }

    // Static

    static styleSelector = 'c-field-select';

    static get observedProps () {
        return [
            new wealthify.Prop('placeholderprop', {default: 'Select an option...'})
        ];
    }

    // Public

    get propCallbacks () {
        return {placeholderprop: () => this.#addPlaceholderOption()};
    }

    constructElementFromStringTemplate (template) {
        return new DOMParser().parseFromString(template, 'text/html').body.firstElementChild;
    }

    addFieldInputElement () {
        if (this.dom.fieldinput?.children) {
            // If options have been added previously, reset them
            wealthify.dom.removeAllParentsChildren(this.dom.fieldinput);
            this.#addPlaceholderOption();
        }

        this.addSelectElement();

        if (this.options) {
            this.options.forEach(option => {
                const item = document.createElement('option');

                item.dataset.fielditem = '';
                item.innerHTML = option.label;
                item.value = option.value;

                this.dom.fieldinput.appendChild(item);
            });

            // Previous attempts to set the value wouldn't have taken affect
            // due to the select element not having any options
            this.#applyValueToInput();
        }
    }

    addSelectElement () {
        if (!this.dom.fieldinput) {
            const selectTemplate = `<select class="${this.styleSelector}__select" data-fieldinput></select>`;
            const iconTemplate = `<w-icon class="${this.styleSelector}__select-icon u-flex__alignitems--center" type="caret-down-filled" size="150" data-field-input-icon></w-icon>`;
            const select = this.constructElementFromStringTemplate(selectTemplate);
            const icon = this.constructElementFromStringTemplate(iconTemplate);

            this.dom.fieldinput = select;
            this.dom.inputcontainer.appendChild(icon);
            this.dom.inputcontainer.appendChild(select);
        }
    }

    formatFieldInputContent () {
        if (this.value) {
            this.dom.fieldinput.value = this.value;
        }

        // Used for external linking directly to the input
        this.dom.fieldlabel.htmlFor = this.dom.fieldinput.id = `${this.name}-input`;
    }

    // Private

    #updateValueFromInput () {
        if (!this.options) {
            // Select value cannot have value until options are set
        }

        this.value = this.dom.fieldinput.value;
    }

    #applyValueToInput () {
        if (!this.options) {
            // Select value cannot be set until it has options
            return;
        }

        const valueMatchesOption = this.options.filter(option => option.value === this?.value?.toString()).length === 1;
        const valueIsEmpty = this.value === '' || this.value === '0';

        if (valueMatchesOption) {
            this.dom.fieldinput.value = this.value;
        } else if (valueIsEmpty) {
            // An intentional empty value would mean that placeholder should be selected
            this.dom.fieldinput.value = this.value = '';
        } else {
            this.#updateValueFromInput();
        }

    }

    #addPlaceholderOption () {
        if (!this.placeholderprop || this.value === undefined) {
            return;
        }

        if (!this.dom.fieldinput)  {
            this.addSelectElement();
        }

        const template = `<option disabled value>${this.placeholderprop}</option>`;
        const placeholderOption = this.constructElementFromStringTemplate(template);

        placeholderOption.selected = this.value === '';
      
        if (this.dom.placeholderOption && this.dom.placeholderOption.isConnected) {
            this.dom.placeholderOption.replaceWith(placeholderOption);
        } else {
            this.dom.fieldinput.prepend(placeholderOption);
        }
            
        this.dom.placeholderOption = placeholderOption;
    }

    #toggleReadOnly() {
        // if read only hide the select box caret icon
        const inputIcon = this.querySelector('[data-field-input-icon]');

        if(inputIcon){
            const classListAction = this.readonlyprop ? 'add' : 'remove';

            inputIcon.classList[classListAction]('u-display__none');
        }
    }
});